// Standard normal distribution — PSD §4.2.3. Engine layer (framework-free).
// Cumulative normal via Abramowitz & Stegun 26.2.17 rational approximation (err <= 7.5e-8).
import { LOG_EXP_CLAMP } from './constants';
/** Standard normal probability density function. */
export function normPDF(x) {
    return Math.exp(-0.5 * x * x) / Math.sqrt(2 * Math.PI);
}
/** Clamp exp argument to avoid overflow, returning a safe exponent. */
export function clampExp(x) {
    if (x > LOG_EXP_CLAMP)
        return LOG_EXP_CLAMP;
    if (x < -LOG_EXP_CLAMP)
        return -LOG_EXP_CLAMP;
    return x;
}
/** Safe exp that clamps the argument to avoid Infinity. */
export function safeExp(x) {
    return Math.exp(clampExp(x));
}
/**
 * Standard normal cumulative distribution function.
 * A&S 26.2.17 rational approximation. Error <= 7.5e-8.
 */
export function normCDF(x) {
    const L = Math.abs(x);
    const K = 1 / (1 + 0.2316419 * L);
    // Polynomial coefficients (A&S 26.2.17)
    const a1 = 0.31938153;
    const a2 = -0.356563782;
    const a3 = 1.781477937;
    const a4 = -1.821255978;
    const a5 = 1.330274429;
    const w = a1 * Math.pow(K, 1) +
        a2 * Math.pow(K, 2) +
        a3 * Math.pow(K, 3) +
        a4 * Math.pow(K, 4) +
        a5 * Math.pow(K, 5);
    const pdf = normPDF(L);
    const cdf = 1 - pdf * w;
    return x >= 0 ? cdf : 1 - cdf;
}
//# sourceMappingURL=norm.js.map